"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getSmallMultiplesScale = getSmallMultiplesScale;
const scales_1 = require("../../scales");
const specs_1 = require("../../specs");
function getSmallMultiplesScale(domain, maxRange, padding = specs_1.DEFAULT_SM_PANEL_PADDING) {
    const singlePanelSmallMultiple = domain.length <= 1;
    return new scales_1.ScaleBand(domain, [0, maxRange], undefined, singlePanelSmallMultiple ? 0 : padding);
}
//# sourceMappingURL=get_small_multiples_scale.js.map